export default __webpack_public_path__ + "static/media/171.be855e7e.png";